import { apiFetch } from '../../../../config/api';

// Request deduplication - prevent multiple identical requests
const pendingRequests = new Map();

/**
 * Helper function for API calls with deduplication (no caching)
 */
export const fetchWithDeduplication = async (url, requestKey) => {
  // Check if request is already pending
  if (pendingRequests.has(requestKey)) {
    return pendingRequests.get(requestKey);
  }

  // Make new request
  const requestPromise = apiFetch(url);
  pendingRequests.set(requestKey, requestPromise);

  try {
    const result = await requestPromise;
    return result;
  } finally {
    // Remove from pending requests
    pendingRequests.delete(requestKey);
  }
};
